import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {
    createBrowserRouter,
    isRouteErrorResponse,
    RouterProvider,
    useRouteError,
} from 'react-router';
import { CssVarsProvider, CssBaseline } from '@mui/joy';
import RoundComponent from './components/Round';
import Layout from './components/Layout';
import MainContent from './components/MainContent';
import ErrorPage from './components/ErrorPage';
import { serviceFacade } from './services/service-facade';

const router = createBrowserRouter([
    {
        ErrorBoundary: RootErrorBoundary,
        Component: Layout,
        children: [
            { index: true, element: <MainContent /> },
            {
                path: '/:roundId/:playerId',
                Component: RoundComponent,
                loader: async ({ params }) => {
                    const response = await serviceFacade.getRound(params.roundId!, params.playerId!);
                    return {
                        round: response,
                    };
                },
            },
        ],
    },
]);

function RootErrorBoundary() {
    let error = useRouteError();
    let message = 'An unexpected error occurred.';
    let status: number | undefined;

    if (isRouteErrorResponse(error)) {
        message = error.data || error.statusText;
        status = error.status;
    } else if (error instanceof Error) {
        message = error.message;
    }

    return (
        <Layout>
            <ErrorPage message={message} status={status} />
        </Layout>
    );
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);
root.render(
    <React.StrictMode>
        <CssVarsProvider>
            <CssBaseline />
            <RouterProvider router={router} />
        </CssVarsProvider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
